import { render, staticRenderFns } from "./tabCustomerOrders.vue?vue&type=template&id=66c350bd&"
import script from "./tabCustomerOrders.vue?vue&type=script&lang=js&"
export * from "./tabCustomerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports